import "babel-polyfill";
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import AppApplicant from './AppApplicant';
import AppExtranet from './AppExtranet';
import Home from "./Components/Pages/Home";
import Applications from "./Components/Pages/Applications";
import AllUploads from "./Components/Pages/AllUploads";
import Password from "./Components/Pages/Password";
import Mailbox from "./Components/Pages/Mailbox";
import Settings from "./Components/Pages/Settings";
import Personal from "./Components/Pages/Personal";
import Overview from "./Components/Pages/Overview";
//import registerServiceWorker from './registerServiceWorker';

var reactApp = {
    root: document.getElementById('root'), // App = Login Control
    rootApplicant: document.getElementById('rootApplicant'), // AppApplicant = Apply Flow ( with integrated login/register module )
    rootExtranet: document.getElementById('rootExtranet'), // AppExtranet = Extranet for organisations
    rootCv: document.getElementById('rootCv'),
    rootApplications: document.getElementById('rootApplications'), // Applications = View of all user-applied applications
    rootAttachments: document.getElementById('rootAttachments'), // Attachments
    rootPassword: document.getElementById('rootPassword'),
    rootPersonal: document.getElementById('rootPersonal'),
    rootHome: document.getElementById('rootHome'),
    rootMailbox: document.getElementById('rootMailbox'),
    rootSettings: document.getElementById('rootSettings'),
    rootOverview: document.getElementById('rootOverview')
}

if (reactApp.root != null) {
    ReactDOM.render(<App />, reactApp.root);
}
if (reactApp.rootApplicant != null) {
    ReactDOM.render(<AppApplicant />, reactApp.rootApplicant);
}
if (reactApp.rootExtranet != null) {
    ReactDOM.render(<AppExtranet />, reactApp.rootExtranet);
}
if (reactApp.rootCv != null) {
    ReactDOM.render(<Applications onlineCv={true} />, reactApp.rootCv);
}
if (reactApp.rootApplications != null) {
    ReactDOM.render(<Applications />, reactApp.rootApplications);
}
if (reactApp.rootAttachments != null) {
    ReactDOM.render(<AllUploads />, reactApp.rootAttachments);
}
if (reactApp.rootPassword != null) {
    ReactDOM.render(<Password />, reactApp.rootPassword);
}
if (reactApp.rootPersonal != null) {
    ReactDOM.render(<Personal />, reactApp.rootPersonal);
}
if (reactApp.rootHome != null) {
    ReactDOM.render(<Home />, reactApp.rootHome);
}
if (reactApp.rootMailbox != null) {
    ReactDOM.render(<Mailbox />, reactApp.rootMailbox);
}
if (reactApp.rootSettings != null) {
    ReactDOM.render(<Settings />, reactApp.rootSettings);
}
if (reactApp.rootOverview != null) {
    ReactDOM.render(<Overview />, reactApp.rootOverview);
}

//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js